import React from 'react';
import { Link } from 'react-router-dom';

const SmallBox = ({ color, value, label, icon, link }) => {
  const isIon = icon && icon.startsWith('ion-');

  return (
    <div className={`col-lg-3 col-6`}>
      <div className={`small-box bg-${color}`}>
        <div className="inner">
          <h3 style={{ fontSize: '2rem', fontWeight: 'bold' }}>{value}</h3>
          <p style={{ fontSize: '1rem' }}>{label}</p>
        </div>
        <div className="icon">
          {/* Aplica la clase 'ion' solo si es necesario */}
          <i className={`${isIon ? 'ion' : ''} ${icon}`}></i>
        </div>
        <Link to={link} className="small-box-footer">
          Más información <i className="fas fa-arrow-circle-right"></i>
        </Link>
      </div>
    </div>
  );
};

export default SmallBox;